module.exports = __webpack_public_path__ + "img/38.cea52232.png";